<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre2" id="pgepubid00000">THE DAY OF THE BEAST</h1>
<h2>Zane Grey</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?782f8541